<template>
  <div
    v-if="data"
    class="grap-page"
  >
    <div class="hero-panel">
      <div class="hero-content">
        <div class="hello-title">
          {{ $t('grapHome.hi') }}, {{ accountName }}
        </div>
        <div class="money-grid">
          <div class="money-cell">
            <div class="money-label">
              {{ $t('grapHome.todayIncome') }}
            </div>
            <div class="money-value">
              {{ utils_moneyMark() }} {{ todayIncome }}
            </div>
          </div>
          <div class="money-cell">
            <div class="money-label">
              {{ $t('grapHome.balance') }}
            </div>
            <div class="money-value">
              {{ utils_moneyMark() }} {{ balanceAmount }}
            </div>
          </div>
        </div>
        <div class="action-grid">
          <button
            type="button"
            class="action-card order-list-card"
            @click="$router.push('/ordering')"
          >
            <span>{{ $t('grapHome.orders') }}</span>
          </button>
          <button
            type="button"
            class="action-card order-card"
            @click="grap()"
          >
            <span>{{ $t('grapHome.startGrabbing') }}</span>
            <small>({{ orderProgressText }})</small>
          </button>
        </div>
        <button
          type="button"
          class="vip-strip"
          @click="$router.push('/vip')"
        >
          <span class="vip-label">{{ $t('grapHome.vip') }}</span>
          <span class="vip-level">{{ $t('grapHome.currentLevel') }}: {{ currentVipName }}</span>
          <img
            v-if="vip"
            :src="vip.img"
            alt=""
            class="vip-medal"
          >
          <van-icon
            name="arrow"
            class="vip-arrow"
          />
        </button>
      </div>
    </div>

    <div class="service-panel">
      <button
        type="button"
        class="service-row"
        @click="$router.push('/cash')"
      >
        <img
          src="../images/ban5/withdraw.png"
          :alt="$t('grapHome.withdrawMoney')"
        >
        <span>{{ $t('grapHome.withdrawMoney') }}</span>
        <van-icon name="arrow" />
      </button>
      <button
        type="button"
        class="service-row"
        @click="$router.push('/kefu')"
      >
        <img
          src="../images/ban5/concat.png"
          :alt="$t('webindex.custserver')"
        >
        <span>{{ $t('webindex.custserver') }}</span>
        <van-icon name="arrow" />
      </button>
      <button
        type="button"
        class="service-row"
        @click="$router.push('/invest')"
      >
        <img
          src="../images/ban5/recharge-tipping.png"
          :alt="$t('moneybag.recharge')"
        >
        <span>{{ $t('moneybag.recharge') }}</span>
        <van-icon name="arrow" />
      </button>
      <button
        type="button"
        class="service-row"
        @click="$router.push('/buy/1')"
      >
        <img
          src="../images/ban5/turntable.png"
          :alt="$t('grapHome.luckyMission')"
        >
        <span>{{ $t('grapHome.luckyMission') }}</span>
        <van-icon name="arrow" />
      </button>
    </div>

    <van-overlay
      :show="show3"
      @click="closeLuckyOrder"
    >
      <div
        class="lucky-wrapper"
        @click.stop
      >
        <div class="lucky-dialog">
          <button
            type="button"
            class="lucky-close"
            @click="closeLuckyOrder"
          >
            <van-icon name="cross" />
          </button>
          <div class="lucky-title">
            {{ $t('grapHome.luckyOrderTitle') }}
          </div>
          <div class="lucky-prize">
            <span>{{ $t('grapHome.luckyOrderCongrats') }}</span>
            <strong>{{ utils_moneyMark() }} {{ formatMoney(order && order.price) }}</strong>
          </div>
          <div class="lucky-commission">
            {{ $t('shopd.commission') }} {{ utils_moneyMark() }}{{ formatMoney(order && order.fee) }}
          </div>
          <button
            type="button"
            class="lucky-action"
            @click="openLuckyOrder"
          >
            {{ $t('grapHome.viewOrders') }}
          </button>
        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="loading-wrapper"
        @click.stop
      >
        <div class="loading-block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('shopd.graping')"
          />
        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="show"
      @click="show = false"
    >
      <div
        class="order-wrapper"
        @click.stop
      >
        <div
          v-if="order"
          class="order-dialog"
        >
          <div class="dialog-header">
            <h3>{{ $t('grapHome.submitAllOrders') }}</h3>
            <button
              type="button"
              class="close-btn"
              @click="show = false"
            >
              <van-icon name="cross" />
            </button>
          </div>
          <div class="dialog-body">
            <div class="order-meta">
              <span>{{ $t('grapHome.timeToRushOrder') }}:</span>
              <strong>{{ order.ct || '--' }}</strong>
            </div>
            <div class="order-meta">
              <span>{{ $t('shopds.onum') }}</span>
              <strong>{{ order.no || '--' }}</strong>
            </div>
            <div class="product-card">
              <img
                :src="order.pic"
                alt=""
              >
              <div class="product-info">
                <div class="product-title">
                  {{ order.title }}
                </div>
                <div class="product-subtitle">
                  {{ orderSubtitle }}
                </div>
              </div>
            </div>
            <div class="order-summary">
              <span>{{ $t('pro.omoney') }}</span>
              <strong>{{ formatMoney(order.price) }}</strong>
              <span>{{ $t('shopd.commission') }}</span>
              <strong class="commission">{{ formatMoney(order.fee) }}</strong>
            </div>
          </div>
          <div class="dialog-actions">
            <button
              type="button"
              class="cancel-btn"
              @click="show = false"
            >
              {{ $t('shopd.cancelbtn') }}
            </button>
            <button
              type="button"
              class="confirm-btn"
              :class="{ disabled: dosubmit }"
              :disabled="dosubmit"
              @click="doorder()"
            >
              {{ $t('grapHome.confirmPayment') }}
            </button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import Vue from 'vue';
	import {
		Dialog,
		Toast,
		Overlay,
		Circle,
		Icon
	} from 'vant';

	Vue.use(Toast)
		.use(Icon)
		.use(Dialog)
		.use(Overlay)
		.use(Circle);

	export default {
		name: "Grap",
		data() {
			return {
				dosubmit:false,
				money:0,
				show1:false,
				conf:false,
				data:null,
				tong:{},
				cashes:null,
				order:null,
				show3:false,
				show:false,
				star:5,
				currentRate:0,
				gradientColor:{
					'0%': '#ffd0ad',
					'100%': '#755f48'
				},
				vip:null,
				vips:null
			};
		},
		computed: {
			moneyMark() {
				return this.$t('utils.moneyMark');
			},
			accountName() {
				if (!this.data) {
					return '--';
				}
				return this.data.mobile || this.data.name || this.data.uid || '--';
			},
			balanceAmount() {
				return this.formatMoney(this.getBalanceValue());
			},
			todayIncome() {
				var value = this.tong && this.tong.tfee !== undefined ? this.tong.tfee : 0;
				return this.formatMoney(value);
			},
			completedOrders() {
				return this.toNumber(this.tong && this.tong.tnum !== undefined ? this.tong.tnum : 0);
			},
			totalOrders() {
				var unfinished = this.toNumber(this.tong && this.tong.anum !== undefined ? this.tong.anum : 0);
				var oingnum = this.toNumber(this.tong && this.tong.oingnum !== undefined ? this.tong.oingnum : 0);
				var total = this.completedOrders + unfinished + oingnum;
				if (total > 0) {
					return total;
				}
				if (this.vip && this.vip.onum !== undefined) {
					return this.toNumber(this.vip.onum);
				}
				return 30;
			},
			orderProgressText() {
				return this.completedOrders + '/' + this.totalOrders;
			},
			currentVipName() {
				if (this.data && this.data.vip_name) {
					return this.data.vip_name;
				}
				if (this.vip && this.vip.name) {
					return this.vip.name;
				}
				if (this.vip && this.vip.no !== undefined) {
					return 'VIP' + this.vip.no;
				}
				return 'VIP';
			},
			orderSubtitle() {
				if (this.order && this.order.level) {
					return this.$t('shopds.numtask') + ' ' + this.order.level;
				}
				return this.$t('shopd.order');
			}
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			this.start();
		},
		methods: {
			toNumber(value) {
				var number = parseFloat(value);
				return isNaN(number) ? 0 : number;
			},
			formatMoney(value) {
				return this.toNumber(value).toFixed(2);
			},
			closeLuckyOrder() {
				this.show3 = false;
			},
			openLuckyOrder() {
				this.show3 = false;
				this.show = true;
			},
			getBalanceValue() {
				if (!this.data) {
					return 0;
				}
				var user = this.data.user || {};
				if (user.money !== undefined) {
					return this.toNumber(user.money);
				}
				if (this.data.money !== undefined) {
					return this.toNumber(this.data.money);
				}
				return this.toNumber(this.data.baoku_money);
			},
			startSlotMachine() {
				this.spinReel(this.$refs.swipe3, 500,100);
				this.spinReel(this.$refs.swipe2, 600,70);
				this.spinReel(this.$refs.swipe1, 700,60);
			},
			spinReel(swipe, duration,interval) {
				if (!swipe || !swipe.next) {
					return;
				}
				var spin = setInterval(() => {
					swipe.next();
				}, interval);
				setTimeout(() => {
					clearInterval(spin);
				}, duration);
			},
			doorder(){
				if(this.dosubmit){
					return false;
				}
				this.dosubmit=true;
				var t = Math.floor(Math.random() * 1000) + 300;
				Toast.loading({
					duration:t,
					forbidClick: true,
					className:'toastc',
					loadingType: 'spinner',
					message: this.$t('d.grap1')
				});
				setTimeout(()=>{
					t = Math.floor(Math.random() * 1000) + 300;
					Toast.loading({
						duration:t,
						forbidClick: true,
						className:'toastc',
						loadingType: 'spinner',
						message: this.$t('d.grap2')
					});
					setTimeout(()=>{
						t = Math.floor(Math.random() * 1000) + 300;
						Toast.loading({
							duration:t,
							forbidClick: true,
							className:'toastc',
							loadingType: 'spinner',
							message: this.$t('d.grap3')
						});
						setTimeout(()=>{
							this.dosuborder();
						},t);
					},t);
				},t);
			},
			dosuborder(){
				Fetch("/user/doorder", {
					id: this.order.id
				}).then(() => {
					this.dosubmit=false;
					this.show = false;
					this.$toast({
						duration:'2000',
						background: '#07c160',
						message: this.$t('shopd.corder')
					});
					this.start();
				}).catch(err=>{
					this.dosubmit=false;
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							className:"dialogstyle",
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.$t('utils.moneyMark')+ err.data.need.toFixed(2)
						})
						.then(() => {
						})
						.catch(() => {
						});
					}
				})
			},
			grapdata(){
				Fetch('/user/grap').then((r) => {
					if(r.data){
						this.order=r.data;
						var price = this.toNumber(this.order.price);
						var orderMoney = this.order.money !== undefined ? this.order.money : this.getBalanceValue();
						this.money = this.formatMoney(this.toNumber(orderMoney) - price);
						this.order.need = this.getBalanceValue() - price;
						if(this.order.need>0){
							this.order.need = 0;
						}else{
							this.order.need = this.formatMoney(this.order.need);
						}
						if(this.order['islucky']){
							this.$toast({
								duration:'5000',
								background: '#07c160',
								message: this.$t('shopd.lorder')
							});
							this.conf =true;
							this.show3=true;
						}else{
							this.show=true;
						}
					}else{
						this.$router.push('/ordering');
					}
				});
			},
			grap(){
				if(this.show1){
					return false;
				}
				this.show1 = true;
				this.conf = false;
				var randomInt = Math.floor(Math.random() * 50) + 20;
				this.currentRate = 0;
				this.graptime(randomInt);
				this.startSlotMachine();
			},
			graptime(randomInt){
				this.currentRate += randomInt;
				if(this.currentRate<100){
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				}else{
					this.show1 = false;
					this.grapdata();
				}
			},
			upvip(){
			},
			start() {
				Fetch("/user/basicinfo").then((r) => {
					var payload = r.data || {};
					this.data = payload;
					this.tong = payload.tong || {};
					this.vip = payload.vip || {};
					this.cashes = payload.cashes;
					this.vips = payload.vips;
					this.money = this.formatMoney(this.getBalanceValue() - this.toNumber(payload.orderprice));
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.grap-page {
		min-height: 100vh;
		padding: 14px 16px 92px;
		background: #191818;
		color: #f5f1ec;
		box-sizing: border-box;
		overflow-x: hidden;
	}

	.hero-panel {
		overflow: hidden;
		position: relative;
		border-radius: 14px;
		border: 1px solid rgba(128, 101, 74, .88);
		background: #292929;
		box-shadow: 0 12px 22px rgba(0, 0, 0, .22);
		box-sizing: border-box;
	}

	.hero-panel:before {
		content: "";
		display: block;
		height: 94px;
		background:
			linear-gradient(180deg, rgba(25, 24, 24, .08) 0%, rgba(35, 35, 35, .9) 100%),
			url(../images/ban5/bg.png) no-repeat top center;
		background-size: cover;
		opacity: .8;
	}

	.hero-content {
		position: relative;
		margin-top: -38px;
		padding: 0 17px 18px;
		box-sizing: border-box;
	}

	.hello-title {
		min-height: 58px;
		padding: 16px;
		border-radius: 12px;
		border: 1px solid rgba(128, 101, 74, .72);
		background: #232323;
		box-sizing: border-box;
		font-size: 18px;
		line-height: 24px;
		font-weight: 800;
		color: #ffc29f;
		word-break: break-all;
	}

	.money-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
		margin-top: 12px;
	}

	.money-cell {
		min-width: 0;
		min-height: 88px;
		padding: 14px 12px;
		border-radius: 12px;
		border: 1px solid rgba(255, 255, 255, .05);
		background: #232323;
		box-sizing: border-box;
	}

	.money-label {
		font-size: 14px;
		line-height: 20px;
		font-weight: 600;
		color: #aeb3bb;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.money-value {
		margin-top: 10px;
		font-size: 20px;
		line-height: 26px;
		font-weight: 800;
		color: #ffd0ad;
		word-break: break-all;
	}

	.action-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
		margin-top: 12px;
	}

	.action-card {
		min-width: 0;
		min-height: 64px;
		border: 1px solid rgba(128, 101, 74, .75);
		border-radius: 12px;
		background: #242322;
		box-sizing: border-box;
		color: #f5f1ec;
		font-size: 14px;
		line-height: 20px;
		font-weight: 800;
		text-align: left;
		padding: 12px 14px;
		position: relative;
		overflow: hidden;
		box-shadow: inset 0 1px 0 rgba(255, 222, 190, .08);
	}

	.action-card span {
		display: block;
		word-break: break-word;
	}

	.action-card small {
		display: block;
		margin-top: 4px;
		font-size: 12px;
		line-height: 16px;
		font-weight: 700;
		color: #ffd0ad;
	}

	.order-list-card {
		color: #d8dde4;
	}

	.order-card {
		border-color: rgba(155, 122, 86, .95);
		background: linear-gradient(180deg, #806348 0%, #604b38 100%);
		color: #ffd0ad;
		text-align: center;
	}

	.vip-strip {
		width: 100%;
		min-height: 68px;
		margin-top: 12px;
		border: 1px solid rgba(128, 101, 74, .72);
		border-radius: 12px;
		background: #232323;
		color: #f5f1ec;
		display: grid;
		grid-template-columns: minmax(0, 1fr) auto 40px 16px;
		align-items: center;
		column-gap: 10px;
		padding: 12px 14px;
		box-sizing: border-box;
		text-align: left;
		position: relative;
	}

	.vip-label {
		font-size: 16px;
		line-height: 22px;
		font-weight: 800;
		color: #ffc29f;
		justify-self: start;
	}

	.vip-level {
		min-width: 0;
		font-size: 14px;
		line-height: 20px;
		font-weight: 500;
		color: #aeb3bb;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		justify-self: start;
	}

	.vip-medal {
		width: 40px;
		height: 40px;
		object-fit: contain;
	}

	.vip-arrow {
		color: #ffd0ad;
		font-size: 16px;
	}

	.service-panel {
		margin-top: 14px;
		padding: 4px 16px;
		border-radius: 14px;
		border: 1px solid rgba(128, 101, 74, .88);
		background: #292929;
		box-shadow: 0 12px 22px rgba(0, 0, 0, .2);
		box-sizing: border-box;
	}

	.service-row {
		width: 100%;
		height: 64px;
		border: 0;
		border-bottom: 1px solid rgba(255, 255, 255, .05);
		background: transparent;
		display: grid;
		grid-template-columns: 44px minmax(0, 1fr) 18px;
		align-items: center;
		column-gap: 12px;
		padding: 0;
		box-sizing: border-box;
		color: #f5f1ec;
		text-align: left;
	}

	.service-row:last-child {
		border-bottom: 0;
	}

	.service-row img {
		width: 34px;
		height: 34px;
		padding: 6px;
		border-radius: 9px;
		object-fit: contain;
		background: rgba(115, 89, 58, .62);
		box-sizing: border-box;
	}

	.service-row span {
		min-width: 0;
		font-size: 14px;
		line-height: 22px;
		font-weight: 700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.service-row .van-icon {
		font-size: 16px;
		color: #aeb3bb;
	}

	.loading-wrapper,
	.lucky-wrapper,
	.order-wrapper {
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.loading-block {
		width: 180px;
		height: 180px;
		padding: 18px;
		border-radius: 18px;
		border: 1px solid rgba(128, 101, 74, .88);
		background: #292929;
		box-shadow: 0 18px 40px rgba(0, 0, 0, .42);
		box-sizing: border-box;
	}

	.lucky-dialog {
		width: calc(100vw - 62px);
		max-width: 334px;
		padding: 19px 22px 22px;
		border-radius: 14px;
		border: 1px solid rgba(128, 101, 74, .88);
		background: #292929;
		box-shadow: 0 20px 48px rgba(0, 0, 0, .55);
		box-sizing: border-box;
		position: relative;
		text-align: center;
	}

	.lucky-close {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 29px;
		height: 29px;
		padding: 0;
		border: 1px solid rgba(255, 255, 255, .1);
		border-radius: 50%;
		background: rgba(255, 255, 255, .15);
		color: #d8dde4;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
	}

	.lucky-title {
		padding: 0 34px;
		color: #ffd0ad;
		font-size: 14px;
		line-height: 22px;
		font-weight: 700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.lucky-prize {
		min-height: 104px;
		margin-top: 14px;
		padding: 19px 12px 16px;
		border-radius: 9px;
		border: 1px solid rgba(255, 218, 160, .45);
		background: linear-gradient(180deg, #fff1bf 0%, #ffe4a2 45%, #fff3cf 100%);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .5);
		box-sizing: border-box;
		color: #6f6254;
	}

	.lucky-prize span {
		display: block;
		font-size: 14px;
		line-height: 20px;
		font-weight: 600;
	}

	.lucky-prize strong {
		display: block;
		margin-top: 10px;
		color: #d99f38;
		font-size: 26px;
		line-height: 32px;
		font-weight: 800;
		word-break: break-word;
	}

	.lucky-commission {
		margin-top: 16px;
		color: #aeb3bb;
		font-size: 14px;
		line-height: 20px;
		font-weight: 700;
		word-break: break-word;
	}

	.lucky-action {
		width: 100%;
		height: 49px;
		margin-top: 20px;
		border: 1px solid rgba(255, 222, 174, .62);
		border-radius: 25px;
		background: linear-gradient(180deg, #ffe4a2 0%, #e7ac58 100%);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .38);
		color: #42392e;
		font-size: 16px;
		line-height: 22px;
		font-weight: 800;
	}

	.order-wrapper {
		align-items: flex-start;
		padding: 118px 16px 20px;
	}

	.order-dialog {
		width: 100%;
		max-width: 462px;
		border-radius: 14px;
		background: #292929;
		border: 1px solid rgba(128, 101, 74, .88);
		box-shadow: 0 20px 48px rgba(0, 0, 0, .55);
		color: #f7f7f7;
		overflow: hidden;
	}

	.dialog-header {
		height: 60px;
		padding: 0 26px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #232323;
		border-bottom: 1px solid rgba(255, 255, 255, .05);
		box-sizing: border-box;
	}

	.dialog-header h3 {
		margin: 0;
		font-size: 14px;
		line-height: 22px;
		font-weight: 800;
		color: #ffc29f;
	}

	.close-btn {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		border: 1px solid rgba(128, 101, 74, .72);
		background: rgba(115, 89, 58, .45);
		color: #ffd0ad;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
	}

	.dialog-body {
		padding: 18px 26px 16px;
		box-sizing: border-box;
	}

	.order-meta {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 14px;
		color: #aeb3bb;
		font-size: 14px;
		line-height: 20px;
	}

	.order-meta strong {
		color: #ffd0ad;
		font-size: 12px;
		line-height: 20px;
		font-weight: 800;
		word-break: break-word;
	}

	.product-card {
		display: grid;
		grid-template-columns: 82px minmax(0, 1fr);
		gap: 14px;
		padding: 15px 16px;
		border: 1px solid rgba(255, 255, 255, .05);
		border-radius: 8px;
		background: #232323;
		box-sizing: border-box;
	}

	.product-card img {
		width: 74px;
		height: 74px;
		border-radius: 5px;
		object-fit: cover;
		background: #111;
	}

	.product-info {
		min-width: 0;
	}

	.product-title {
		font-size: 12px;
		line-height: 22px;
		font-weight: 800;
		color: #f5f1ec;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.product-subtitle {
		margin-top: 8px;
		font-size: 12px;
		line-height: 16px;
		color: #aeb3bb;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.order-summary {
		height: 62px;
		margin-top: 16px;
		padding: 0 16px;
		border-radius: 8px;
		border: 1px solid rgba(128, 101, 74, .62);
		background: #232323;
		display: grid;
		grid-template-columns: auto 1fr auto 1fr;
		align-items: center;
		column-gap: 10px;
		box-sizing: border-box;
	}

	.order-summary span {
		font-size: 14px;
		line-height: 20px;
		color: #aeb3bb;
	}

	.order-summary strong {
		font-size: 16px;
		line-height: 22px;
		font-weight: 800;
		color: #f5f1ec;
		word-break: break-word;
	}

	.order-summary .commission {
		color: #ffc29f;
	}

	.dialog-actions {
		display: grid;
		grid-template-columns: 1fr 1.6fr;
		gap: 22px;
		padding: 22px 26px 20px;
		box-sizing: border-box;
	}

	.dialog-actions button {
		height: 45px;
		border-radius: 8px;
		font-size: 14px;
		line-height: 20px;
		font-weight: 800;
	}

	.cancel-btn {
		border: 1px solid rgba(255, 255, 255, .08);
		background: #232323;
		color: #aeb3bb;
	}

	.confirm-btn {
		border: 1px solid rgba(155, 122, 86, .95);
		background: linear-gradient(180deg, #806348 0%, #604b38 100%);
		color: #ffd0ad;
	}

	.confirm-btn.disabled {
		opacity: .65;
	}

	/deep/ .van-overlay {
		position: fixed;
		background-color: rgba(0, 0, 0, .72);
	}

	/deep/ .van-circle__text {
		color: #ffd0ad;
		font-size: 14px;
		font-weight: 700;
	}

	@media (max-width: 360px) {
		.grap-page {
			padding-right: 12px;
			padding-left: 12px;
		}

		.hero-content {
			padding-right: 12px;
			padding-left: 12px;
		}

		.hello-title {
			font-size: 16px;
		}

		.money-grid,
		.action-grid {
			gap: 8px;
		}

		.money-label {
			font-size: 14px;
		}

		.money-value {
			font-size: 16px;
		}

		.action-card {
			font-size: 12px;
			padding-right: 10px;
			padding-left: 10px;
		}

		.vip-strip {
			grid-template-columns: minmax(0, 1fr) 38px 16px;
		}

		.vip-level {
			display: none;
		}

		.vip-label,
		.vip-level,
		.service-row span {
			font-size: 14px;
		}

		.order-wrapper {
			padding-right: 12px;
			padding-left: 12px;
		}

		.order-summary {
			grid-template-columns: auto 1fr;
			height: auto;
			row-gap: 4px;
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
</style>
